/** Download the invoice as a PDF. */
export const tenantBillingInvoicePdfGetSpec = {
    uri: '/t/[tenant]/billing/invoice/[invoice]/pdf',
    method: 'GET',
};
